import {MultimediaManagerDialogSidenavFolder} from '../multimedia-manager-dialog-sidenav/multimedia-manager-dialog-sidenav-folder.model';
import { Injectable, isDevMode } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { MultimediaManagerDaoService } from '../multimedia-manager-daos/multimedia-manager-dao.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ParserService } from '../parser.service';
import { tap, map, take } from 'rxjs/operators';
import { MultimediaManagerDialogItem } from './multimedia-manager-dialog-item.model';

@Injectable({
  providedIn: 'root'
})
export class MultimediaManagerDialogService {

  private folderChangedListener = new Subject<any>();
  private goHomeListener = new Subject<any>();
  private setModeListener = new Subject<any>();
  private multiOption: boolean;
  private editor: boolean;
  currentFolder;

  constructor(private multimediaManagerDaoService: MultimediaManagerDaoService,
              private userStorageService: UserStorageService,
              private parserService: ParserService) { }

  public getItems(folderId): Observable<any> {
    return this.multimediaManagerDaoService.getItems(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), folderId).pipe(
      tap(res => { if (isDevMode()) { console.dir(res); } }),
      map((res) => {
        const items = new Array<MultimediaManagerDialogItem>();
        res['data']['elementList'].forEach(
          (i) => {
            items.push(this.parserService.parseItem(i));
          }
        );
        const fatherFolder = Object.assign(new MultimediaManagerDialogSidenavFolder, res['data']['folderFather']);
        return { items, fatherFolder };
      })
    );
  }

  public getInitialFolders(): Observable<any> {
    return this.multimediaManagerDaoService.getInitialFolders(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
      tap(res => { if (isDevMode()) { console.dir(res); } }),
      map((res) => {
        const items = new Array<MultimediaManagerDialogItem>();
        res['data']['elementList'].forEach(
          (i) => {
            items.push(this.parserService.parseItem(i));
          }
        );
        const fatherFolder = Object.assign(new MultimediaManagerDialogSidenavFolder, res['data']['folderFather']);
        return { items, fatherFolder };
      })
    );
  }

  public listenFolderChanged() {
    return this.folderChangedListener.asObservable();
  }

  public folderChanged(folder: MultimediaManagerDialogSidenavFolder): any {
    this.getItems(folder.InternalId).pipe(
      take(1),
      map(
        (res) => {
          this.currentFolder = folder;
          this.folderChangedListener.next({ items: res.items, currentFolder: folder, currentFatherFolder: res.fatherFolder });
        })
    ).subscribe();
  }

  public listenGoHome() {
    return this.goHomeListener.asObservable();
  }

  public goHome() {
    this.goHomeListener.next();
  }

  public listenSetMode() {
    return this.setModeListener.asObservable();
  }

  public setMode(mode, element) {
    this.setModeListener.next({ mode, element });
  }

  public getCurrentFolder() {
    return this.currentFolder;
  }

  public setMultiOption(multiOption) {
    this.multiOption = multiOption;
  }

  public getMultiOption() {
    return this.multiOption;
  }
  public setEditorOption(editor) {
    this.editor = editor;
  }

  public getEditorOption() {
    return this.editor;
  }
}

